import $ from "jquery";
import "slick-carousel";

const testimonialsSection = () => {
  const target = ".mi-Testimonials__cases";
  const $target = $(target);

  const init = () => {
    // const width = window.innerWidth;
    // console.log(`width`, width);
    // if ($target.length && width <= 1024) {
    //   exec();
    // }

    if ($target.length && window.matchMedia("(max-width: 1024px)").matches) {
      exec();
    }
  };

  const exec = () => {
    $target.slick({
      // arrows: true,
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 3,
      centerMode: true,
      initialSlide: 1,
      variableWidth: true,
    });
  };

  const handleChangeTitleCases = () => {
    const casesTitle = ".mi-CasesTitle";
    const casesSubtitle = ".mi-CasesSubtitle";

    $(casesTitle).each(function (index) {
      const text = $(this).text();
      const parts = text.split("|");

      $(this)
        .find("p")
        .text(parts[0].trim() || "");
      $(casesSubtitle)
        .eq(index)
        .find("p")
        .text(parts[1]?.trim() || "");
    });
  };

  init();
  handleChangeTitleCases();
};

try {
  testimonialsSection();
} catch (error) {
  throw Error(error);
}
